<template>
  <p>
      404
   Запрашиваемая страница не найдена
  </p>
</template>
<script>
export default {
  name: 'NotFound'
};
</script>
<style scoped>
p {
    margin-top: 70px;
    font-weight: bold;
    font-size: 50px;
    text-align: center;
    color: #f10b0b;
}
</style>